import classnames from 'classnames';
import { Badge } from 'reactstrap';
import { NormalButton } from '@/shared/ui';
import { defaultControlModalValue } from '@/entities/report';
import useButtonAddNewEvent from './useButtonAddNewEvent';

/**
 * Draft panel on the ECG events tab, showing how many draft events exist and offering to add another. Renders a badge that turns red once the draft count is above zero, opens the new-events modal by resetting the control modal state with isShowNewEvents set, and delegates the Add New Event button to the hook's handler.
 *
 * @returns The draft button with its count badge and the add-new-event action.
 */
const ButtonAddNewEvent = () => {
  const { eventLength, onClickAddNewEvent, setControlModal } = useButtonAddNewEvent();

  return (
    <div className="function-btn">
      <button
        id="draft-btn"
        className="draft-btn"
        onClick={() => {
          setControlModal({
            ...defaultControlModalValue,
            isShowNewEvents: true,
          });
        }}
      >
        <Badge className={classnames(eventLength > 0 ? 'custom-badge-red' : 'custom-badge-gray')}>
          {eventLength}
        </Badge>
        <div className="draft-title">Draft</div>
        <div className="draft-description">Click to view all.</div>
        <NormalButton
          id="add-new-event-btn"
          className="add-new-event-btn"
          buttonName="Add New Event"
          onClick={onClickAddNewEvent}
        />
      </button>
    </div>
  );
};

export default ButtonAddNewEvent;
